import React from 'react';
import { Badge } from '../ui/Badge';

interface ProfileStatusBadgeProps {
  status: string;
  type: 'onboarding' | 'submission';
  className?: string;
}

export const ProfileStatusBadge: React.FC<ProfileStatusBadgeProps> = ({ 
  status, 
  type,
  className 
}) => {
  const getOnboardingStatusVariant = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'default'
      case 'in_progress':
        return 'secondary'
      case 'draft':
        return 'outline'
      default:
        return 'secondary'
    }
  }

  const getSubmissionStatusVariant = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
        return 'outline'
      case 'processing':
        return 'secondary'
      case 'processed':
      case 'completed':
        return 'default'
      case 'failed':
        return 'destructive'
      default:
        return 'outline'
    }
  }

  const variant = type === 'onboarding' 
    ? getOnboardingStatusVariant(status)
    : getSubmissionStatusVariant(status);

  const label = type === 'onboarding' 
    ? `Onboarding: ${status}`
    : status;

  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
};